import logo from "./aether-robotics-logo.jpg"; // Adjust the filename as necessary
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>Coming Soon...</p>
      </header>
    </div>
  );
}

export default App;
